
// import React, { useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { FaChevronUp, FaChevronDown } from "react-icons/fa";
// import { MdContentCopy } from "react-icons/md";

// // Import CSS files
// import "../Dashboard Style/core.css";
// import "../Dashboard Style/flatpickr.min.css";
// import "../assets1/css/custom.css";
// import "../assets1/css/style.css";

// // Import images
// import logo from "../assets1/images/logo.webp";
// import usFlag from "../assets1/images/flags/us.svg";
// import frFlag from "../assets1/images/flags/fr.svg";
// import face2 from "../assets1/images/faces/face2.webp";
// import face3 from "../assets1/images/faces/face3.webp";
// import face4 from "../assets1/images/faces/face4.webp";
// import face5 from "../assets1/images/faces/face5.webp";
// import face6 from "../assets1/images/faces/face6.webp";
// import qrCodeImage from "../assets/images/qr-code.jpeg";
// import { setActiveDate, setPaymentSubmitted } from "../Redux/user_information";
// import Sidebar from "./Core/Sidebar";
// import Navbar from "./Core/Navbar";

// const Dashboard = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const authToken = useSelector((state) => state.user?.token);
//   const userData = useSelector((state) => state.user?.userData);
//   console.log("userData : ", userData)
//   const hasSubmittedPayment = useSelector((state) => state.user?.hasSubmittedPayment);
//   const userActiveDate = userData?.active_date;

//   console.log("authToken : ", authToken);
//   console.log("hasSubmittedPayment : ", hasSubmittedPayment);
//   console.log("userActiveDate : ", userActiveDate);

//   const [showPaymentPopup, setShowPaymentPopup] = useState(false);
//   const [showActivationPopup, setShowActivationPopup] = useState(false);
//   const [transferHash, setTransferHash] = useState("");
//   const [isProcessing, setIsProcessing] = useState(false);

//   // State for sidebar and dropdowns
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [openDropdowns, setOpenDropdowns] = useState({});

//   console.log("userData : ", userData)

//   // Wallet data - using Redux values for first 3, static for last 2
//   const walletData = {
//     quantumMainVault: userData?.wallets?.main_wallet || 0,
//     quantumRelease: userData?.wallets?.release_wallet || 0,
//     quantumCurrent: userData?.wallets?.current_wallet || 0,
//     quantumQiAirdrop: 0, // Static value
//     totalReferrals: userData?.referral_count
//   };

//   // const sponsorLinks = [
//   //   {
//   //     id: 1,
//   //     name: "Sponsor ID",
//   //     link: "http://localhost:3000/register?sponsor_code=WQ13242514",
//   //     icon: "user-plus"
//   //   },
//   //   {
//   //     id: 2,
//   //     name: "Position Left",
//   //     link: "http://localhost:3000/register?placement_code=WQ13242514&position=Left",
//   //     icon: "arrow-left"
//   //   },
//   //   {
//   //     id: 3,
//   //     name: "Position Right",
//   //     link: "http://localhost:3000/register?placement_code=WQ13242514&position=Right",
//   //     icon: "arrow-right"
//   //   }
//   // ];


//   // Generate referral links

//   const sponsorLinks = [
//     {
//       id: 1,
//       name: "Sponsor ID",
//       link: `https://home.oceaniabloom9.com/register?sponsor_code=${userData.user_code}`,
//       icon: "user-plus"
//     },
//     {
//       id: 2,
//       name: "Position Left",
//       link: `https://home.oceaniabloom9.com/register?placement_code=${userData.user_code}&position=Left`,
//       icon: "arrow-left"
//     },
//     {
//       id: 3,
//       name: "Position Right",
//       link: `https://home.oceaniabloom9.com/register?placement_code=${userData.user_code}&position=Right`,
//       icon: "arrow-right"
//     }
//   ];

//   const generateReferralLinks = () => {
//     const baseUrl = "https://admin.oceaniabloom9.com/register";
//     const sponsorCode = "WQ13242514"; // This should come from userData

//     return {
//       sponsorLink: `${baseUrl}?placement_code=${sponsorCode}`,
//       positionLeft: `${baseUrl}?placement_code=${sponsorCode}-position-left`,
//       positionRight: `${baseUrl}?placement_code=${sponsorCode}-position-right`
//     };
//   };

//   const referralLinks = generateReferralLinks();

//   // Add this function near your other API functions
//   const handleActivateSelfByWallet = async () => {
//     try {
//       setIsProcessing(true);

//       const response = await fetch(`https://admin.oceaniabloom9.com/api/user/active-self-by-wallet`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/x-www-form-urlencoded',
//           'Authorization': `Bearer ${authToken}`,
//         },
//         body: new URLSearchParams({
//           // Add any required parameters here if needed
//           // Based on the image, it might not need any body parameters
//         })
//       });

//       const data = await response.json();

//       if (data.status) {
//         // Activation successful
//         dispatch(setPaymentSubmitted());
//         const currentDate = new Date().toISOString().split('T')[0];
//         dispatch(setActiveDate(currentDate));
//         showNotification("Account activated successfully using wallet balance!", "success");
//         setShowPaymentPopup(false);
//       } else {
//         showNotification(data.message || "Activation failed. Please try again.", "error");
//       }
//     } catch (error) {
//       console.error('Error activating by wallet:', error);
//       showNotification("Failed to activate account. Please try again.", "error");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   // Update the handleWalletSubmit function
//   const handleWalletSubmit = (e) => {
//     e.preventDefault();

//     if (!hasSufficientBalance) {
//       showNotification("Insufficient wallet balance. Please add funds.", "error");
//       return;
//     }

//     if (window.confirm(`Confirm registration payment of $${requiredAmount} from your wallet?`)) {
//       handleActivateSelfByWallet();
//     }
//   };

//   // Toggle sidebar
//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Toggle dropdown
//   const toggleDropdown = (dropdownId) => {
//     setOpenDropdowns(prev => ({
//       ...prev,
//       [dropdownId]: !prev[dropdownId]
//     }));
//   };

//   // Initialize sidebar functionality
//   useEffect(() => {
//     const sidebar = document.querySelector('.sidebar');
//     const sidebarBody = document.querySelector('.sidebar-body');

//     if (sidebar) {
//       if (sidebarOpen) {
//         sidebar.classList.remove('close');
//       } else {
//         sidebar.classList.add('close');
//       }
//     }

//     // Add custom scrollbar to sidebar body
//     if (sidebarBody) {
//       sidebarBody.style.height = 'calc(100vh - 70px)';
//       sidebarBody.style.overflowY = 'auto';
//     }

//     return () => {
//       // Cleanup
//     };
//   }, [sidebarOpen]);

//   useEffect(() => {
//     // Show payment popup only if payment hasn't been submitted
//     if (!hasSubmittedPayment) {
//       setShowPaymentPopup(true);
//     }

//     // Show activation popup if active_date is null
//     if (!userActiveDate) {
//       setShowActivationPopup(true);
//     }

//     // Initialize all dropdowns as closed by default
//     const initialDropdownState = {
//       dashboard: false,
//       fundManagement: false,
//       registrationTeam: false,
//       incomeEarnings: false,
//       bonanzaRewards: false,
//       airdrop: false,
//       withdrawal: false,
//       settings: false
//     };
//     setOpenDropdowns(initialDropdownState);
//   }, [hasSubmittedPayment, userActiveDate]);

//   useEffect(() => {
//     // Add custom scrollbar styles
//     const style = document.createElement('style');
//     style.innerHTML = `
//       /* Custom scrollbar for sidebar */
//       .sidebar-body {
//         height: calc(100vh - 70px);
//         overflow-y: auto;
//       }
      
//       .sidebar-body::-webkit-scrollbar {
//         width: 6px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-track {
//         background: rgba(255, 255, 255, 0.05);
//         border-radius: 10px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-thumb {
//         background: rgba(255, 255, 255, 0.2);
//         border-radius: 10px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-thumb:hover {
//         background: rgba(255, 255, 255, 0.3);
//       }
      
//       /* Custom scrollbar for modal */
//       .modal-body {
//         max-height: 70vh;
//         overflow-y: auto;
//       }
      
//       .modal-body::-webkit-scrollbar {
//         width: 8px;
//       }
      
//       .modal-body::-webkit-scrollbar-track {
//         background: #f1f1f1;
//         border-radius: 10px;
//       }
      
//       .modal-body::-webkit-scrollbar-thumb {
//         background: #888;
//         border-radius: 10px;
//       }
      
//       .modal-body::-webkit-scrollbar-thumb:hover {
//         background: #555;
//       }
      
//       /* Notification styles */
//       .notification {
//         animation: slideIn 0.3s ease-out;
//         position: fixed;
//         top: 20px;
//         right: 20px;
//         z-index: 9999;
//         min-width: 300px;
//       }
      
//       @keyframes slideIn {
//         from {
//           transform: translateX(100%);
//           opacity: 0;
//         }
//         to {
//           transform: translateX(0);
//           opacity: 1;
//         }
//       }
      
//       /* Smooth transitions */
//       .sidebar {
//         transition: all 0.3s ease;
//       }
      
//       .modal {
//         transition: opacity 0.3s ease;
//       }
      
//       /* Adjust column width for 4 boxes in a row */
//       .col-md-4 {
//         width: 25%;
//         flex: 0 0 25%;
//         max-width: 25%;
//       }
      
//       /* Single box below takes full width */
//       .col-md-12-single {
//         width: 100%;
//         flex: 0 0 100%;
//         max-width: 100%;
//       }
      
//       @media (max-width: 1200px) {
//         .col-md-4 {
//           width: 50%;
//           flex: 0 0 50%;
//           max-width: 50%;
//         }
//       }
      
//       @media (max-width: 768px) {
//         .col-md-4 {
//           width: 100%;
//           flex: 0 0 100%;
//           max-width: 100%;
//         }
//       }
      
//       /* Sidebar dropdown menu styles */
//       .sidebar .nav-dropdown {
//         list-style: none;
//         padding-left: 0;
//         max-height: 0;
//         overflow: hidden;
//         transition: max-height 0.3s ease;
//       }
      
//       .sidebar .nav-dropdown.show {
//         max-height: 500px;
//       }
      
//       .sidebar .nav-dropdown-item {
//         padding-left: 2.5rem;
//       }
      
//       /* Sidebar dropdown toggle with icon */
//       .nav-item.has-dropdown .nav-link {
//         position: relative;
//         padding-right: 2.5rem;
//       }
      
//       .nav-item.has-dropdown .dropdown-icon {
//         position: absolute;
//         right: 1rem;
//         top: 50%;
//         transform: translateY(-50%);
//         transition: transform 0.3s ease;
//       }
      
//       .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
//         transform: translateY(-50%) rotate(180deg);
//       }
      
//       /* Improved dropdown styling similar to first image */
//       .nav-item.has-dropdown .nav-dropdown {
//         background: rgba(255, 255, 255, 0.05);
//         border-left: 3px solid var(--primary-color, #0d6efd);
//         margin-left: 1rem;
//         border-radius: 0 0 8px 8px;
//       }
      
//       .nav-item.has-dropdown .nav-dropdown-item .nav-link {
//         padding: 0.75rem 1rem 0.75rem 2rem;
//         color: rgba(255, 255, 255, 0.8);
//       }
      
//       .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
//         background: rgba(255, 255, 255, 0.1);
//         color: white;
//       }
      
//       /* Box styling */
//       .custom-card {
//         position: relative;
//         border-radius: 10px;
//         overflow: hidden;
//         background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
//         border: 1px solid #e9ecef;
//         transition: all 0.3s ease;
//       }
      
//       .custom-card:hover {
//         transform: translateY(-5px);
//         box-shadow: 0 10px 20px rgba(0,0,0,0.1);
//       }
      
//       .custom-card .top-left,
//       .custom-card .top-right,
//       .custom-card .bottom-left,
//       .custom-card .bottom-right {
//         position: absolute;
//         width: 20px;
//         height: 20px;
//         border-color: var(--primary-color, #0d6efd);
//       }
      
//       .custom-card .top-left {
//         top: 0;
//         left: 0;
//         border-top: 2px solid;
//         border-left: 2px solid;
//       }
      
//       .custom-card .top-right {
//         top: 0;
//         right: 0;
//         border-top: 2px solid;
//         border-right: 2px solid;
//       }
      
//       .custom-card .bottom-left {
//         bottom: 0;
//         left: 0;
//         border-bottom: 2px solid;
//         border-left: 2px solid;
//       }
      
//       .custom-card .bottom-right {
//         bottom: 0;
//         right: 0;
//         border-bottom: 2px solid;
//         border-right: 2px solid;
//       }
      
//       /* Fix for category text styling */
//       .nav-item.has-dropdown .link-title.nav-item.nav-category {
//         font-weight: 600;
//         font-size: 0.875rem;
//         text-transform: uppercase;
//         letter-spacing: 0.5px;
//       }
      
//       /* Year Planner Table Styles */
//       .year-planner-table {
//         width: 100%;
//         border-collapse: collapse;
//         margin-top: 20px;
//         font-size: 12px;
//       }
      
//       .year-planner-table th {
//         background-color: #f8f9fa;
//         border: 1px solid #dee2e6;
//         padding: 8px;
//         text-align: center;
//         font-weight: 600;
//       }
      
//       .year-planner-table td {
//         border: 1px solid #dee2e6;
//         padding: 8px;
//         text-align: center;
//         height: 40px;
//         vertical-align: middle;
//       }
      
//       .year-planner-table .day-header {
//         background-color: #e9ecef;
//         font-weight: 600;
//         width: 80px;
//       }
      
//       .year-planner-table .month-header {
//         background-color: #0d6efd;
//         color: white;
//       }
      
//       .year-planner-table tr:hover td {
//         background-color: #f8f9fa;
//       }
      
//       /* Referral Links Card Styles */
//       .referral-link-card {
//         margin-bottom: 10px;
//       }
      
//       .referral-link-input {
//         font-size: 12px;
//         font-family: 'Courier New', monospace;
//       }
      
//       .copy-btn {
//         min-width: 70px;
//       }
      
//       /* Activation Popup Styles */
//       .activation-popup {
//         background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//         color: white;
//         border-radius: 10px;
//         overflow: hidden;
//       }
      
//       .activation-icon {
//         font-size: 4rem;
//         color: #ffd700;
//       }
//     `;
//     document.head.appendChild(style);

//     return () => {
//       document.head.removeChild(style);
//     };
//   }, []);

//   const handleSubmitPayment = async (e) => {
//     e.preventDefault();

//     if (!transferHash.trim()) {
//       showNotification("Please enter transfer hash", "error");
//       return;
//     }

//     setIsProcessing(true);

//     try {
//       // Create FormData object
//       const formData = new FormData();
//       formData.append('hash_id', transferHash);

//       const response = await fetch(`https://admin.oceaniabloom9.com/api/user/register-payment`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${authToken}`,
//           'Accept': 'application/json',
//         },
//         body: formData
//       });

//       const result = await response.json();

//       if (response.ok) {
//         if (result.success) {
//           // IMPORTANT: Dispatch action to mark payment as submitted
//           dispatch(setPaymentSubmitted());

//           showNotification("Payment submitted successfully!", "success");
//           setTransferHash("");
//           setShowPaymentPopup(false);

//           showNotification(`Transaction ID: ${result.transaction_id || result.data?.transactionId || result.id}`, "info");
//         } else {
//           showNotification(result.message || "Payment submission failed. Please try again.", "error");
//         }
//       } else {
//         // Handle HTTP errors
//         if (response.status === 401) {
//           showNotification("Session expired. Please log in again.", "error");
//           navigate('/signin');
//         } else if (response.status === 400) {
//           showNotification(result.message || "Invalid request. Please check your input.", "error");
//         } else if (response.status === 422) {
//           showNotification(result.message || "Validation error. Please check your input.", "error");
//         } else {
//           showNotification(result.message || "Server error. Please try again later.", "error");
//         }
//       }
//     } catch (error) {
//       console.error("Payment submission error:", error);
//       showNotification("Network error. Please check your connection and try again.", "error");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   const handleCopyToClipboard = (text, label) => {
//     navigator.clipboard.writeText(text)
//       .then(() => {
//         showNotification(`${label} copied to clipboard!`, "success");
//       })
//       .catch(err => {
//         console.error("Failed to copy: ", err);
//         showNotification("Failed to copy to clipboard", "error");
//       });
//   };

//   const handleCopyAddress = () => {
//     const address = "0xf22380424e0dfc7170b484d8833dc737d0957c53";
//     handleCopyToClipboard(address, "Address");
//   };

//   const handleClosePopup = () => {
//     setShowPaymentPopup(false);
//   };

//   const handleCloseActivationPopup = () => {
//     setShowActivationPopup(false);
//   };

//   const handleActivateAccount = () => {
//     // Here you would make an API call to activate the account
//     // For now, we'll just simulate activation
//     const currentDate = new Date().toISOString().split('T')[0];

//     // Dispatch action to update active_date
//     dispatch(setActiveDate(currentDate));

//     showNotification("Account activated successfully!", "success");
//     setShowActivationPopup(false);

//     // In a real app, you would make an API call here
//     // Example:
//     // fetch(`https://admin.oceaniabloom9.com/api/user/activate-account`, {
//     //   method: 'POST',
//     //   headers: {
//     //     'Authorization': `Bearer ${authToken}`,
//     //     'Content-Type': 'application/json',
//     //   },
//     //   body: JSON.stringify({ activation_date: currentDate })
//     // })
//   };

//   const showNotification = (message, type = "info") => {
//     // Create notification element
//     const notification = document.createElement('div');
//     notification.className = `notification alert alert-${type === 'error' ? 'danger' : type} alert-dismissible fade show`;
//     notification.innerHTML = `
//       <div class="d-flex align-items-center">
//         <i data-lucide="${type === 'success' ? 'check-circle' : type === 'error' ? 'alert-circle' : 'info'}" class="me-2"></i>
//         <span>${message}</span>
//         <button type="button" class="btn-close ms-auto" data-bs-dismiss="alert"></button>
//       </div>
//     `;

//     // Add to body
//     document.body.appendChild(notification);

//     // Auto remove after 5 seconds
//     setTimeout(() => {
//       if (notification.parentNode) {
//         notification.remove();
//       }
//     }, 5000);
//   };

//   // Year Planner Table Component (as shown in your image)
//   const YearPlannerTable = () => {
//     const months = ['JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER'];
//     const days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
//     const rows = 18; // As shown in your image

//     return (
//       <div className="card custom-card mt-4">
//         <div className="top-left"></div>
//         <div className="top-right"></div>
//         <div className="bottom-left"></div>
//         <div className="bottom-right"></div>
//         <div className="card-body">
//           <div className="d-flex justify-content-between align-items-baseline mb-3">
//             <h6 className="card-title mb-0">
//               <i className="me-2" data-lucide="calendar"></i>
//               YEAR PLANNER
//             </h6>
//           </div>

//           <div className="table-responsive">
//             <table className="year-planner-table">
//               <thead>
//                 <tr>
//                   <th className="day-header">DAY</th>
//                   {months.map((month, index) => (
//                     <th key={index} className="month-header">{month}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {Array.from({ length: rows }).map((_, rowIndex) => (
//                   <tr key={rowIndex}>
//                     <td className="day-header">{days[rowIndex % days.length]}</td>
//                     {months.map((month, monthIndex) => (
//                       <td key={monthIndex}></td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className="mt-4">
//             <div className="row">
//               <div className="col-md-6">
//                 <div className="d-flex align-items-center mb-2">
//                   <i className="me-2" data-lucide="user" style={{ color: '#0d6efd' }}></i>
//                   <span className="fw-bold">Semper Id</span>
//                 </div>
//                 <div className="d-flex align-items-center mb-1">
//                   <span className="text-muted small me-2">placements - left</span>
//                   <i className="me-2" data-lucide="arrow-left" style={{ color: '#28a745' }}></i>
//                 </div>
//                 <div className="d-flex align-items-center mb-1">
//                   <span className="text-muted small me-2">placement - right</span>
//                   <i className="me-2" data-lucide="arrow-right" style={{ color: '#dc3545' }}></i>
//                 </div>
//                 <div className="d-flex align-items-center">
//                   <span className="text-muted small me-2">p</span>
//                   <i className="me-2" data-lucide="circle" style={{ color: '#ffc107' }}></i>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const SponsorLinksTable = () => {
//     return (
//       <div className="card custom-card mt-4">
//         <div className="top-left"></div>
//         <div className="top-right"></div>
//         <div className="bottom-left"></div>
//         <div className="bottom-right"></div>
//         <div className="card-body">
//           <div className="d-flex justify-content-between align-items-baseline mb-3">
//             <h6 className="card-title mb-0 text-white">
//               <i className="me-2" data-lucide="link"></i>
//               Sponsor Links
//             </h6>
//           </div>

//           <div className="table-responsive">
//             <table className="sponsor-links-table table">
//               <thead>
//                 <tr className="border-bottom border-secondary">
//                   <th className="text-white fw-medium" style={{ width: '70%' }}>Link Name</th>
//                   <th className="text-white fw-medium" style={{ width: '30%' }}>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {sponsorLinks.map((link) => (
//                   <tr key={link.id} className="border-bottom border-secondary">
//                     <td className="py-3">
//                       <div className="sponsor-link-cell d-flex align-items-center">
//                         <i className={`text-white me-2`} data-lucide={link.icon}></i>
//                         <span className="fw-medium text-white">{link.name}</span>
//                       </div>
//                     </td>
//                     <td className="py-3">
//                       <button
//                         className="btn btn-outline-light btn-sm copy-btn-small"
//                         onClick={() => handleCopyToClipboard(link.link, link.name)}
//                         type="button"
//                       >
//                         {/* <i className="me-1" data-lucide="copy"></i> Copy */}
//                         <MdContentCopy />
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     );
//   };
//   const [paymentMethod, setPaymentMethod] = useState('hash'); // 'hash' or 'wallet'
//   const currentWalletBalance = userData?.main_wallet || 0;
//   const requiredAmount = 5;
//   const hasSufficientBalance = currentWalletBalance >= requiredAmount;
//   const PaymentPopup = () => {
//     // Don't show if payment has been submitted or if user already has active_date
//     if (!showPaymentPopup || hasSubmittedPayment || userActiveDate) return null;


//     const handleWalletSubmit = (e) => {
//       e.preventDefault();

//       if (!hasSufficientBalance) {
//         showNotification("Insufficient wallet balance. Please add funds.", "error");
//         return;
//       }

//       if (window.confirm(`Confirm registration payment of $${requiredAmount} from your wallet?`)) {
//         // Handle wallet payment logic here
//         console.log('Wallet payment initiated');

//         // Simulate API call
//         setIsProcessing(true);
//         setTimeout(() => {
//           setIsProcessing(false);
//           dispatch(setPaymentSubmitted());
//           const currentDate = new Date().toISOString().split('T')[0];
//           dispatch(setActiveDate(currentDate));
//           showNotification("Registration completed successfully using wallet balance!", "success");
//           setShowPaymentPopup(false);
//         }, 1500);
//       }
//     };

//     return (
//       <div className="modal-backdrop show d-block" style={{
//         backgroundColor: 'rgba(0,0,0,0.7)',
//         backdropFilter: 'blur(3px)'
//       }}>
//         <div className="modal d-block" tabIndex="-1" style={{ zIndex: 1050 }}>
//           <div className="modal-dialog modal-dialog-centered modal-lg">
//             <div className="modal-content border-0 shadow-lg">
//               <div className="modal-header bg-primary text-white">
//                 <h5 className="modal-title mb-0 d-flex align-items-center">
//                   <i className="me-2" data-lucide="credit-card"></i>
//                   Registration Payment Required
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close btn-close-white"
//                   onClick={handleClosePopup}
//                 ></button>
//               </div>
//               <div className="modal-body p-4">
//                 {/* Payment Method Toggle */}
//                 <div className="payment-method-toggle mb-4">
//                   <div className="toggle-buttons d-flex bg-light rounded p-1">
//                     <button
//                       className={`toggle-btn1 flex-fill ${paymentMethod === 'hash' ? 'active' : ''}`}
//                       onClick={() => setPaymentMethod('hash')}
//                     >
//                       <i className="me-2" data-lucide="hash"></i>
//                       Active via Hash
//                     </button>
//                     <button
//                       className={`toggle-btn1 flex-fill ${paymentMethod === 'wallet' ? 'active' : ''}`}
//                       onClick={() => setPaymentMethod('wallet')}
//                     >
//                       <i className="me-2" data-lucide="wallet"></i>
//                       Active via Wallet
//                     </button>
//                   </div>
//                 </div>

//                 {/* Payment Method Indicator */}
//                 <div className="alert alert-info mb-4">
//                   <div className="d-flex align-items-center">
//                     <i className="me-2" data-lucide={paymentMethod === 'hash' ? 'hash' : 'wallet'}></i>
//                     <div>
//                       <h6 className="mb-1">{paymentMethod === 'hash' ? 'Hash Payment Method' : 'Wallet Payment Method'}</h6>
//                       <p className="mb-0 small">
//                         {paymentMethod === 'hash'
//                           ? 'Submit your transaction hash to verify payment'
//                           : 'Use your wallet balance to complete registration'}
//                       </p>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Hash Payment Method (Already Done) */}
//                 {paymentMethod === 'hash' && (
//                   <div className="payment-details">
//                     <div className="row mb-4">
//                       <div className="col-12">
//                         <div className="card border-primary">
//                           <div className="card-header bg-primary text-white">
//                             <h6 className="mb-0">Registration Fees</h6>
//                           </div>
//                           <div className="card-body">
//                             <div className="row">
//                               <div className="col-md-8">
//                                 <h5 className="text-primary mb-2">Willow Quantum</h5>
//                                 <div className="d-flex align-items-center mb-3">
//                                   <i className="me-2" data-lucide="coin" style={{ color: '#00a478' }}></i>
//                                   <span className="fw-bold">USDT (BEP20)</span>
//                                 </div>

//                                 <div className="mb-3">
//                                   <label className="form-label text-muted small mb-1">Receiving Address</label>
//                                   <div className="input-group">
//                                     <input
//                                       type="text"
//                                       className="form-control bg-light referral-link-input"
//                                       value="0xf22380424e0dfc7170b484d8833dc737d0957c53"
//                                       readOnly
//                                     />
//                                     <button
//                                       className="btn btn-outline-primary copy-btn"
//                                       onClick={handleCopyAddress}
//                                       type="button"
//                                     >
//                                       <i className="me-1" data-lucide="copy"></i> Copy
//                                     </button>
//                                   </div>
//                                 </div>
//                               </div>
//                               <div className="col-md-4">
//                                 <div className="text-center">
//                                   <div className="card bg-light">
//                                     <div className="qr-placeholder bg-white rounded">
//                                       <img
//                                         src={qrCodeImage}
//                                         alt="Payment QR Code"
//                                         style={{
//                                           width: "100%",
//                                           objectFit: 'contain'
//                                         }}
//                                       />
//                                     </div>
//                                   </div>
//                                   <p className="text-muted small mt-2 mb-0">Scan QR Code</p>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="row mb-4">
//                       <div className="col-12">
//                         <div className="alert alert-success">
//                           <div className="d-flex align-items-center justify-content-between">
//                             <div>
//                               <h5 className="mb-1">Fixed Payment Amount</h5>
//                               <h2 className="text-dark mb-0">$5 USD</h2>
//                             </div>
//                             <div className="text-end">
//                               <div className="badge bg-primary fs-6">Already Done</div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <form onSubmit={handleSubmitPayment}>
//                       <div className="mb-4">
//                         <label htmlFor="transferHash" className="form-label fw-bold">
//                           <i className="me-2" data-lucide="hash"></i>
//                           Transaction Hash / TXID
//                         </label>
//                         <input
//                           type="text"
//                           className="form-control form-control-lg referral-link-input"
//                           id="transferHash"
//                           placeholder="Enter your transaction hash"
//                           value={transferHash}
//                           onChange={(e) => setTransferHash(e.target.value)}
//                           required
//                         />
//                       </div>

//                       <div className="d-grid gap-2">
//                         <button
//                           type="submit"
//                           className="btn btn-primary btn-lg py-3"
//                           disabled={isProcessing}
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center"
//                           }}
//                         >
//                           {isProcessing ? (
//                             <>
//                               <span className="spinner-border spinner-border-sm me-2" role="status"></span>
//                               Processing Payment...
//                             </>
//                           ) : (
//                             <>
//                               <i className="me-2" data-lucide="check-circle"></i>
//                               Submit Payment Verification
//                             </>
//                           )}
//                         </button>
//                       </div>
//                     </form>
//                   </div>
//                 )}

//                 {/* Wallet Payment Method */}
//                 {/* Wallet Payment Method */}
//                 {paymentMethod === 'wallet' && (
//                   <div className="wallet-payment-details">
//                     <div className="row mb-4">
//                       <div className="col-12">
//                         <div className="alert alert-warning">
//                           <div className="d-flex align-items-center justify-content-between">
//                             <div>
//                               <h5 className="mb-1">Registration Fees Required</h5>
//                               <h2 className="text-dark mb-0">$5 USD</h2>
//                             </div>
//                             <div className="text-end">
//                               <div className="badge bg-warning fs-6">Required Amount</div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     {/* Current Wallet Balance */}
//                     <div className="row mb-4">
//                       <div className="col-12">
//                         <div className="card border-success">
//                           <div className="card-header bg-success text-white">
//                             <h6 className="mb-0 d-flex align-items-center">
//                               <i className="me-2" data-lucide="wallet"></i>
//                               Current wallet amount
//                             </h6>
//                           </div>
//                           <div className="card-body">
//                             <div className="text-center py-4">
//                               <div className="display-1 fw-bold text-success mb-2">
//                                 ${currentWalletBalance.toFixed(2)}
//                               </div>
//                               <p className="text-muted mb-0">Available for registration payment</p>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>



//                     {/* Register Free */}
//                     {/* <div className="row mb-4">
//       <div className="col-12">
//         <div className="card border-info">
//           <div className="card-header bg-info text-white">
//             <h6 className="mb-0 d-flex align-items-center">
//               <i className="me-2" data-lucide="gift"></i>
//               Register Free
//             </h6>
//           </div>
//           <div className="card-body">
//             <div className="text-center">
//               <h4 className="text-info mb-3">→ $5</h4>
//               <p className="mb-2">
//                 If wallet → $5 and greater then
//               </p>
//               <div className={`mt-3 ${hasSufficientBalance ? 'text-success' : 'text-danger'}`}>
//                 <i className="me-2" data-lucide={hasSufficientBalance ? 'check-circle' : 'x-circle'}></i>
//                 {hasSufficientBalance 
//                   ? `Your balance ($${currentWalletBalance.toFixed(2)}) is sufficient` 
//                   : `You need $${(requiredAmount - currentWalletBalance).toFixed(2)} more`}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div> */}

//                     {/* Balance Status */}
//                     <div className="row mb-4">
//                       <div className="col-12">
//                         <div className={`balance-status-card ${hasSufficientBalance ? 'bg-success' : 'bg-danger'}`}>
//                           <div className="d-flex align-items-center justify-content-between">
//                             <div className="d-flex align-items-center">
//                               {/* <div className={`status-icon ${hasSufficientBalance ? 'text-success' : 'text-danger'}`}>
//                 <i data-lucide={hasSufficientBalance ? 'check-circle' : 'alert-circle'}></i>
//               </div> */}
//                               <div className="ms-3">
//                                 <h6 className="mb-1">
//                                   {hasSufficientBalance ? 'Sufficient Balance ✓' : 'Insufficient Balance ✗'}
//                                 </h6>
//                                 <p className="mb-0 small">
//                                   {hasSufficientBalance
//                                     ? `Your wallet has $${currentWalletBalance.toFixed(2)}, which meets the $${requiredAmount} requirement`
//                                     : `You need $${(requiredAmount - currentWalletBalance).toFixed(2)} more to proceed`}
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Submit Button - Only show if sufficient balance */}
//                     {hasSufficientBalance && (
//                       <form onSubmit={handleWalletSubmit}>
//                         <div className="d-grid gap-2">
//                           <button
//                             type="submit"
//                             className="btn btn-success btn-lg py-3"
//                             disabled={isProcessing}
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center"
//                             }}
//                           >
//                             {isProcessing ? (
//                               <>
//                                 <span className="spinner-border spinner-border-sm me-2" role="status"></span>
//                                 Processing Activation...
//                               </>
//                             ) : (
//                               <>
//                                 <i className="me-2" data-lucide="check-circle"></i>
//                                 Activate Account via Wallet
//                               </>
//                             )}
//                           </button>
//                         </div>
//                       </form>
//                     )}

//                     {/* Insufficient Balance Message */}
//                     {/* {!hasSufficientBalance && (
//       <div className="insufficient-balance-message">
//         <div className="alert alert-danger">
//           <div className="d-flex align-items-center">
//             <i className="me-3" data-lucide="alert-circle"></i>
//             <div>
//               <h6 className="mb-1">Insufficient Balance</h6>
//               <p className="mb-0">
//                 You need <strong>${(requiredAmount - currentWalletBalance).toFixed(2)}</strong> more in your wallet.
//                 Please use the "Hash Payment" method or add funds to your wallet.
//               </p>
//             </div>
//           </div>
//         </div>
        
//         <div className="text-center mt-3">
//           <button
//             className="btn btn-outline-primary"
//             onClick={() => setPaymentMethod('hash')}
//           >
//             <i className="me-2" data-lucide="hash"></i>
//             Switch to Hash Payment
//           </button>
//         </div>
//       </div>
//     )} */}
//                   </div>
//                 )}
//               </div>


//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <>
//       <PaymentPopup />


//       <div className="main-wrapper">
//         {/* Sidebar with custom scrollbar */}
//         <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
//           <div className="sidebar-header">
//             <a href="#" className="sidebar-brand">
//               <i className="me-2" data-lucide="atom"></i>
//               Willow <span>Quantum</span>
//             </a>
//             <div className="sidebar-toggler" onClick={toggleSidebar}>
//               <span></span>
//               <span></span>
//               <span></span>
//             </div>
//           </div>
//           <Sidebar />
//         </nav>

//         <div className="page-wrapper">
//           {/* Navbar */}
//           <Navbar />
//           {/* Page Content */}
//           <div className="page-content container-xxl">
//             {/* Stats Cards Row - UPDATED: 4 BOXES IN ONE ROW */}
//             <div className="row">
//               <div className="col-12 col-xl-12 stretch-card">
//                 <div className="row flex-grow-1">
//                   {/* First Row: 4 Boxes */}
//                   <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">User Details</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5" style={{ width: "100%" }}>

//                             <p style={{ marginBottom: "0px", color: "white" }}>User Id : {userData?.user_code}</p>
//                             <p style={{ marginBottom: "0px", color: "white" }}>Account Name : {userData?.account_name}</p>
//                             <p style={{ marginBottom: "0px", color: "white" }}>Email : {userData?.email}</p>
//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="referralsChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">Plan Details</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5" style={{ width: "100%" }}>
//                             <p style={{ marginBottom: "0px", color: "white" }}>PLan : Awaiting</p>
//                             <p style={{ marginBottom: "0px", color: "white" }}>Rank : Awaiting</p>
//                             <span style={{ marginBottom: "0px", color: "white" }}>Status : </span>
//                             <button
//                               className={userData.user_code ? "status-btn active" : "status-btn inactive"}
//                             >
//                               {userData.user_code ? "Active" : "Inactive"}
//                             </button>

//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="referralsChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   {/* Box 1: Total Referrals */}
//                   <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">Total Referrals</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5">
//                             <h3 className="mb-2">{userData?.referral_count}</h3>
//                             <small className="text-muted">Active Referrals</small>
//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="referralsChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Box 2: Quantum Main Vault */}
//                   <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">Quantum Main Vault (Fuel)</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5">
//                             <h3 className="mb-2">${walletData.quantumMainVault.toLocaleString()}</h3>
//                             <small className="text-muted">Fuel Balance</small>
//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="mainVaultChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Box 3: Quantum Release */}
//                   <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">Quantum Release (Withdrawal)</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5">
//                             <h3 className="mb-2">${walletData.quantumRelease.toLocaleString()}</h3>
//                             <small className="text-muted">Withdrawal Balance</small>
//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="releaseChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Box 4: Quantum Current */}
//                   <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">Quantum Current (Liquidity)</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5">
//                             <h3 className="mb-2">${walletData.quantumCurrent.toLocaleString()}</h3>
//                             <small className="text-muted">Liquidity Balance</small>
//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="currentChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                    <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">Quantum Qi-Airdrop</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                          <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5">
//                             <h3 className="mb-2">${walletData.quantumQiAirdrop.toLocaleString()}</h3>
//                             <small className="text-muted">Airdrop Balance</small>
//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="airdropChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                 </div>
//               </div>
//             </div>

//             <SponsorLinksTable />


//           </div>

//           {/* Footer */}
//           <footer className="footer d-flex flex-row align-items-center justify-content-center px-4 py-3 border-top small">
//             <p className="text-secondary mb-1 mb-md-0">Copyright © 2025 Willow Quantum. All Right Reserved.</p>
//           </footer>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Dashboard;

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { MdContentCopy } from "react-icons/md";
import { toast } from 'react-toastify'; // Import toast

// Import CSS files
import "../Dashboard Style/core.css";
import "../Dashboard Style/flatpickr.min.css";
import "../assets1/css/custom.css";
import "../assets1/css/style.css";

// Import images
import logo from "../assets1/images/logo.webp";
import usFlag from "../assets1/images/flags/us.svg";
import frFlag from "../assets1/images/flags/fr.svg";
import face2 from "../assets1/images/faces/face2.webp";
import face3 from "../assets1/images/faces/face3.webp";
import face4 from "../assets1/images/faces/face4.webp";
import face5 from "../assets1/images/faces/face5.webp";
import face6 from "../assets1/images/faces/face6.webp";
import qrCodeImage from "../assets/images/qr-code.jpeg";
import { setActiveDate, setPaymentSubmitted } from "../Redux/user_information";
import Sidebar from "./Core/Sidebar";
import Navbar from "./Core/Navbar";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authToken = useSelector((state) => state.user?.token);
  const userData = useSelector((state) => state.user?.userData);
  console.log("userData : ", userData)
  const hasSubmittedPayment = useSelector((state) => state.user?.hasSubmittedPayment);
  const userActiveDate = userData?.active_date;

  console.log("authToken : ", authToken);
  console.log("hasSubmittedPayment : ", hasSubmittedPayment);
  console.log("userActiveDate : ", userActiveDate);

  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [showActivationPopup, setShowActivationPopup] = useState(false);
  const [transferHash, setTransferHash] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  // State for sidebar and dropdowns
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [openDropdowns, setOpenDropdowns] = useState({});

  console.log("userData : ", userData)

  // Wallet data - using Redux values for first 3, static for last 2
  const walletData = {
    quantumMainVault: userData?.wallets?.main_wallet || 0,
    quantumRelease: userData?.wallets?.release_wallet || 0,
    quantumCurrent: userData?.wallets?.current_wallet || 0,
    quantumQiAirdrop: 0, // Static value
    totalReferrals: userData?.referral_count
  };

  // Generate referral links
  const sponsorLinks = [
    {
      id: 1,
      name: "Sponsor ID",
      link: `https://home.oceaniabloom9.com/register?sponsor_code=${userData.user_code}`,
      icon: "user-plus"
    },
    {
      id: 2,
      name: "Position Left",
      link: `https://home.oceaniabloom9.com/register?placement_code=${userData.user_code}&position=Left`,
      icon: "arrow-left"
    },
    {
      id: 3,
      name: "Position Right",
      link: `https://home.oceaniabloom9.com/register?placement_code=${userData.user_code}&position=Right`,
      icon: "arrow-right"
    }
  ];

  const generateReferralLinks = () => {
    const baseUrl = "https://admin.oceaniabloom9.com/register";
    const sponsorCode = "WQ13242514"; // This should come from userData

    return {
      sponsorLink: `${baseUrl}?placement_code=${sponsorCode}`,
      positionLeft: `${baseUrl}?placement_code=${sponsorCode}-position-left`,
      positionRight: `${baseUrl}?placement_code=${sponsorCode}-position-right`
    };
  };

  const referralLinks = generateReferralLinks();

  // Add this function near your other API functions
  const handleActivateSelfByWallet = async () => {
    try {
      setIsProcessing(true);

      const response = await fetch(`https://admin.oceaniabloom9.com/api/user/active-self-by-wallet`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Bearer ${authToken}`,
        },
        body: new URLSearchParams({
          // Add any required parameters here if needed
          // Based on the image, it might not need any body parameters
        })
      });

      const data = await response.json();

      if (data.status) {
        // Activation successful
        dispatch(setPaymentSubmitted());
        const currentDate = new Date().toISOString().split('T')[0];
        dispatch(setActiveDate(currentDate));
        toast.success("Account activated successfully using wallet balance!");
        setShowPaymentPopup(false);
      } else {
        toast.error(data.message || "Activation failed. Please try again.");
      }
    } catch (error) {
      console.error('Error activating by wallet:', error);
      toast.error("Failed to activate account. Please try again.");
    } finally {
      setIsProcessing(false);
    }
  };

  // Update the handleWalletSubmit function
  const handleWalletSubmit = (e) => {
    e.preventDefault();

    if (!hasSufficientBalance) {
      toast.error("Insufficient wallet balance. Please add funds.");
      return;
    }

    // Replace window.confirm with custom confirmation using toast
    toast.info(
      <div>
        <p>Confirm registration payment of ${requiredAmount} from your wallet?</p>
        <div className="d-flex justify-content-center gap-2 mt-2">
          <button 
            className="btn btn-sm btn-success"
            onClick={() => {
              handleActivateSelfByWallet();
              toast.dismiss();
            }}
          >
            Confirm
          </button>
          <button 
            className="btn btn-sm btn-secondary"
            onClick={() => toast.dismiss()}
          >
            Cancel
          </button>
        </div>
      </div>,
      {
        autoClose: false,
        closeButton: false,
        closeOnClick: false,
      }
    );
  };

  // Toggle sidebar
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Toggle dropdown
  const toggleDropdown = (dropdownId) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [dropdownId]: !prev[dropdownId]
    }));
  };

  // Initialize sidebar functionality
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');

    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }

    // Add custom scrollbar to sidebar body
    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    return () => {
      // Cleanup
    };
  }, [sidebarOpen]);

  useEffect(() => {
    // Show payment popup only if payment hasn't been submitted
    if (!hasSubmittedPayment) {
      setShowPaymentPopup(true);
    }

    // Show activation popup if active_date is null
    if (!userActiveDate) {
      setShowActivationPopup(true);
    }

    // Initialize all dropdowns as closed by default
    const initialDropdownState = {
      dashboard: false,
      fundManagement: false,
      registrationTeam: false,
      incomeEarnings: false,
      bonanzaRewards: false,
      airdrop: false,
      withdrawal: false,
      settings: false
    };
    setOpenDropdowns(initialDropdownState);
  }, [hasSubmittedPayment, userActiveDate]);

  useEffect(() => {
    // Add custom scrollbar styles
    const style = document.createElement('style');
    style.innerHTML = `
      /* Custom scrollbar for sidebar */
      .sidebar-body {
        height: calc(100vh - 70px);
        overflow-y: auto;
      }
      
      .sidebar-body::-webkit-scrollbar {
        width: 6px;
      }
      
      .sidebar-body::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      
      /* Custom scrollbar for modal */
      .modal-body {
        max-height: 70vh;
        overflow-y: auto;
      }
      
      .modal-body::-webkit-scrollbar {
        width: 8px;
      }
      
      .modal-body::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }
      
      .modal-body::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
      }
      
      .modal-body::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
      
      /* Notification styles */
      .notification {
        animation: slideIn 0.3s ease-out;
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 9999;
        min-width: 300px;
      }
      
      @keyframes slideIn {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      
      /* Smooth transitions */
      .sidebar {
        transition: all 0.3s ease;
      }
      
      .modal {
        transition: opacity 0.3s ease;
      }
      
      /* Adjust column width for 4 boxes in a row */
      .col-md-4 {
        width: 25%;
        flex: 0 0 25%;
        max-width: 25%;
      }
      
      /* Single box below takes full width */
      .col-md-12-single {
        width: 100%;
        flex: 0 0 100%;
        max-width: 100%;
      }
      
      @media (max-width: 1200px) {
        .col-md-4 {
          width: 50%;
          flex: 0 0 50%;
          max-width: 50%;
        }
      }
      
      @media (max-width: 768px) {
        .col-md-4 {
          width: 100%;
          flex: 0 0 100%;
          max-width: 100%;
        }
      }
      
      /* Sidebar dropdown menu styles */
      .sidebar .nav-dropdown {
        list-style: none;
        padding-left: 0;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
      }
      
      .sidebar .nav-dropdown.show {
        max-height: 500px;
      }
      
      .sidebar .nav-dropdown-item {
        padding-left: 2.5rem;
      }
      
      /* Sidebar dropdown toggle with icon */
      .nav-item.has-dropdown .nav-link {
        position: relative;
        padding-right: 2.5rem;
      }
      
      .nav-item.has-dropdown .dropdown-icon {
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        transition: transform 0.3s ease;
      }
      
      .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
        transform: translateY(-50%) rotate(180deg);
      }
      
      /* Improved dropdown styling similar to first image */
      .nav-item.has-dropdown .nav-dropdown {
        background: rgba(255, 255, 255, 0.05);
        border-left: 3px solid var(--primary-color, #0d6efd);
        margin-left: 1rem;
        border-radius: 0 0 8px 8px;
      }
      
      .nav-item.has-dropdown .nav-dropdown-item .nav-link {
        padding: 0.75rem 1rem 0.75rem 2rem;
        color: rgba(255, 255, 255, 0.8);
      }
      
      .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
        background: rgba(255, 255, 255, 0.1);
        color: white;
      }
      
      /* Box styling */
      .custom-card {
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
        border: 1px solid #e9ecef;
        transition: all 0.3s ease;
      }
      
      .custom-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0,0,0,0.1);
      }
      
      .custom-card .top-left,
      .custom-card .top-right,
      .custom-card .bottom-left,
      .custom-card .bottom-right {
        position: absolute;
        width: 20px;
        height: 20px;
        border-color: var(--primary-color, #0d6efd);
      }
      
      .custom-card .top-left {
        top: 0;
        left: 0;
        border-top: 2px solid;
        border-left: 2px solid;
      }
      
      .custom-card .top-right {
        top: 0;
        right: 0;
        border-top: 2px solid;
        border-right: 2px solid;
      }
      
      .custom-card .bottom-left {
        bottom: 0;
        left: 0;
        border-bottom: 2px solid;
        border-left: 2px solid;
      }
      
      .custom-card .bottom-right {
        bottom: 0;
        right: 0;
        border-bottom: 2px solid;
        border-right: 2px solid;
      }
      
      /* Fix for category text styling */
      .nav-item.has-dropdown .link-title.nav-item.nav-category {
        font-weight: 600;
        font-size: 0.875rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      
      /* Year Planner Table Styles */
      .year-planner-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 20px;
        font-size: 12px;
      }
      
      .year-planner-table th {
        background-color: #f8f9fa;
        border: 1px solid #dee2e6;
        padding: 8px;
        text-align: center;
        font-weight: 600;
      }
      
      .year-planner-table td {
        border: 1px solid #dee2e6;
        padding: 8px;
        text-align: center;
        height: 40px;
        vertical-align: middle;
      }
      
      .year-planner-table .day-header {
        background-color: #e9ecef;
        font-weight: 600;
        width: 80px;
      }
      
      .year-planner-table .month-header {
        background-color: #0d6efd;
        color: white;
      }
      
      .year-planner-table tr:hover td {
        background-color: #f8f9fa;
      }
      
      /* Referral Links Card Styles */
      .referral-link-card {
        margin-bottom: 10px;
      }
      
      .referral-link-input {
        font-size: 12px;
        font-family: 'Courier New', monospace;
      }
      
      .copy-btn {
        min-width: 70px;
      }
      
      /* Activation Popup Styles */
      .activation-popup {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        border-radius: 10px;
        overflow: hidden;
      }
      
      .activation-icon {
        font-size: 4rem;
        color: #ffd700;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const handleSubmitPayment = async (e) => {
    e.preventDefault();

    if (!transferHash.trim()) {
      toast.error("Please enter transfer hash");
      return;
    }

    setIsProcessing(true);

    try {
      // Create FormData object
      const formData = new FormData();
      formData.append('hash_id', transferHash);

      const response = await fetch(`https://admin.oceaniabloom9.com/api/user/register-payment`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Accept': 'application/json',
        },
        body: formData
      });

      const result = await response.json();

      if (response.ok) {
        if (result.success) {
          // IMPORTANT: Dispatch action to mark payment as submitted
          dispatch(setPaymentSubmitted());

          toast.success("Payment submitted successfully!");
          setTransferHash("");
          setShowPaymentPopup(false);

          toast.info(`Transaction ID: ${result.transaction_id || result.data?.transactionId || result.id}`);
        } else {
          toast.error(result.message || "Payment submission failed. Please try again.");
        }
      } else {
        // Handle HTTP errors
        if (response.status === 401) {
          toast.error("Session expired. Please log in again.");
          navigate('/signin');
        } else if (response.status === 400) {
          toast.error(result.message || "Invalid request. Please check your input.");
        } else if (response.status === 422) {
          toast.error(result.message || "Validation error. Please check your input.");
        } else {
          toast.error(result.message || "Server error. Please try again later.");
        }
      }
    } catch (error) {
      console.error("Payment submission error:", error);
      toast.error("Network error. Please check your connection and try again.");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleCopyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        toast.success(`${label} copied to clipboard!`);
      })
      .catch(err => {
        console.error("Failed to copy: ", err);
        toast.error("Failed to copy to clipboard");
      });
  };

  const handleCopyAddress = () => {
    const address = "0xf22380424e0dfc7170b484d8833dc737d0957c53";
    handleCopyToClipboard(address, "Address");
  };

  const handleClosePopup = () => {
    setShowPaymentPopup(false);
  };

  const handleCloseActivationPopup = () => {
    setShowActivationPopup(false);
  };

  const handleActivateAccount = () => {
    // Here you would make an API call to activate the account
    // For now, we'll just simulate activation
    const currentDate = new Date().toISOString().split('T')[0];

    // Dispatch action to update active_date
    dispatch(setActiveDate(currentDate));

    toast.success("Account activated successfully!");
    setShowActivationPopup(false);

    // In a real app, you would make an API call here
    // Example:
    // fetch(`https://admin.oceaniabloom9.com/api/user/activate-account`, {
    //   method: 'POST',
    //   headers: {
    //     'Authorization': `Bearer ${authToken}`,
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({ activation_date: currentDate })
    // })
  };

  const showNotification = (message, type = "info") => {
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `notification alert alert-${type === 'error' ? 'danger' : type} alert-dismissible fade show`;
    notification.innerHTML = `
      <div class="d-flex align-items-center">
        <i data-lucide="${type === 'success' ? 'check-circle' : type === 'error' ? 'alert-circle' : 'info'}" class="me-2"></i>
        <span>${message}</span>
        <button type="button" class="btn-close ms-auto" data-bs-dismiss="alert"></button>
      </div>
    `;

    // Add to body
    document.body.appendChild(notification);

    // Auto remove after 5 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.remove();
      }
    }, 5000);
  };

  // Year Planner Table Component (as shown in your image)
  const YearPlannerTable = () => {
    const months = ['JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER'];
    const days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
    const rows = 18; // As shown in your image

    return (
      <div className="card custom-card mt-4">
        <div className="top-left"></div>
        <div className="top-right"></div>
        <div className="bottom-left"></div>
        <div className="bottom-right"></div>
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-baseline mb-3">
            <h6 className="card-title mb-0">
              <i className="me-2" data-lucide="calendar"></i>
              YEAR PLANNER
            </h6>
          </div>

          <div className="table-responsive">
            <table className="year-planner-table">
              <thead>
                <tr>
                  <th className="day-header">DAY</th>
                  {months.map((month, index) => (
                    <th key={index} className="month-header">{month}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: rows }).map((_, rowIndex) => (
                  <tr key={rowIndex}>
                    <td className="day-header">{days[rowIndex % days.length]}</td>
                    {months.map((month, monthIndex) => (
                      <td key={monthIndex}></td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4">
            <div className="row">
              <div className="col-md-6">
                <div className="d-flex align-items-center mb-2">
                  <i className="me-2" data-lucide="user" style={{ color: '#0d6efd' }}></i>
                  <span className="fw-bold">Semper Id</span>
                </div>
                <div className="d-flex align-items-center mb-1">
                  <span className="text-muted small me-2">placements - left</span>
                  <i className="me-2" data-lucide="arrow-left" style={{ color: '#28a745' }}></i>
                </div>
                <div className="d-flex align-items-center mb-1">
                  <span className="text-muted small me-2">placement - right</span>
                  <i className="me-2" data-lucide="arrow-right" style={{ color: '#dc3545' }}></i>
                </div>
                <div className="d-flex align-items-center">
                  <span className="text-muted small me-2">p</span>
                  <i className="me-2" data-lucide="circle" style={{ color: '#ffc107' }}></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const SponsorLinksTable = () => {
    return (
      <div className="card custom-card mt-4">
        <div className="top-left"></div>
        <div className="top-right"></div>
        <div className="bottom-left"></div>
        <div className="bottom-right"></div>
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-baseline mb-3">
            <h6 className="card-title mb-0 text-white">
              <i className="me-2" data-lucide="link"></i>
              Sponsor Links
            </h6>
          </div>

          <div className="table-responsive">
            <table className="sponsor-links-table table">
              <thead>
                <tr className="border-bottom border-secondary">
                  <th className="text-white fw-medium" style={{ width: '70%' }}>Link Name</th>
                  <th className="text-white fw-medium" style={{ width: '30%' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {sponsorLinks.map((link) => (
                  <tr key={link.id} className="border-bottom border-secondary">
                    <td className="py-3">
                      <div className="sponsor-link-cell d-flex align-items-center">
                        <i className={`text-white me-2`} data-lucide={link.icon}></i>
                        <span className="fw-medium text-white">{link.name}</span>
                      </div>
                    </td>
                    <td className="py-3">
                      <button
                        className="btn btn-outline-light btn-sm copy-btn-small"
                        onClick={() => handleCopyToClipboard(link.link, link.name)}
                        type="button"
                      >
                        <MdContentCopy />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };
  const [paymentMethod, setPaymentMethod] = useState('hash'); // 'hash' or 'wallet'
  const currentWalletBalance = userData?.main_wallet || 0;
  const requiredAmount = 5;
  const hasSufficientBalance = currentWalletBalance >= requiredAmount;
  
  const PaymentPopup = () => {
    // Don't show if payment has been submitted or if user already has active_date
    if (!showPaymentPopup || hasSubmittedPayment || userActiveDate) return null;

    return (
      <div className="modal-backdrop show d-block" style={{
        backgroundColor: 'rgba(0,0,0,0.7)',
        backdropFilter: 'blur(3px)'
      }}>
        <div className="modal d-block" tabIndex="-1" style={{ zIndex: 1050 }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title mb-0 d-flex align-items-center">
                  <i className="me-2" data-lucide="credit-card"></i>
                  Registration Payment Required
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={handleClosePopup}
                ></button>
              </div>
              <div className="modal-body p-4">
                {/* Payment Method Toggle */}
                <div className="payment-method-toggle mb-4">
                  <div className="toggle-buttons d-flex bg-light rounded p-1">
                    <button
                      className={`toggle-btn1 flex-fill ${paymentMethod === 'hash' ? 'active' : ''}`}
                      onClick={() => setPaymentMethod('hash')}
                    >
                      <i className="me-2" data-lucide="hash"></i>
                      Active via Hash
                    </button>
                    <button
                      className={`toggle-btn1 flex-fill ${paymentMethod === 'wallet' ? 'active' : ''}`}
                      onClick={() => setPaymentMethod('wallet')}
                    >
                      <i className="me-2" data-lucide="wallet"></i>
                      Active via Wallet
                    </button>
                  </div>
                </div>

                {/* Payment Method Indicator */}
                <div className="alert alert-info mb-4">
                  <div className="d-flex align-items-center">
                    <i className="me-2" data-lucide={paymentMethod === 'hash' ? 'hash' : 'wallet'}></i>
                    <div>
                      <h6 className="mb-1">{paymentMethod === 'hash' ? 'Hash Payment Method' : 'Wallet Payment Method'}</h6>
                      <p className="mb-0 small">
                        {paymentMethod === 'hash'
                          ? 'Submit your transaction hash to verify payment'
                          : 'Use your wallet balance to complete registration'}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Hash Payment Method (Already Done) */}
                {paymentMethod === 'hash' && (
                  <div className="payment-details">
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="card border-primary">
                          <div className="card-header bg-primary text-white">
                            <h6 className="mb-0">Registration Fees</h6>
                          </div>
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-8">
                                <h5 className="text-primary mb-2">Willow Quantum</h5>
                                <div className="d-flex align-items-center mb-3">
                                  <i className="me-2" data-lucide="coin" style={{ color: '#00a478' }}></i>
                                  <span className="fw-bold">USDT (BEP20)</span>
                                </div>

                                <div className="mb-3">
                                  <label className="form-label text-muted small mb-1">Receiving Address</label>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control bg-light referral-link-input"
                                      value="0xf22380424e0dfc7170b484d8833dc737d0957c53"
                                      readOnly
                                    />
                                    <button
                                      className="btn btn-outline-primary copy-btn"
                                      onClick={handleCopyAddress}
                                      type="button"
                                    >
                                      <i className="me-1" data-lucide="copy"></i> Copy
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="text-center">
                                  <div className="card bg-light">
                                    <div className="qr-placeholder bg-white rounded">
                                      <img
                                        src={qrCodeImage}
                                        alt="Payment QR Code"
                                        style={{
                                          width: "100%",
                                          objectFit: 'contain'
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <p className="text-muted small mt-2 mb-0">Scan QR Code</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="alert alert-success">
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <h5 className="mb-1">Fixed Payment Amount</h5>
                              <h2 className="text-dark mb-0">$5 USD</h2>
                            </div>
                            <div className="text-end">
                              <div className="badge bg-primary fs-6">Already Done</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <form onSubmit={handleSubmitPayment}>
                      <div className="mb-4">
                        <label htmlFor="transferHash" className="form-label fw-bold">
                          <i className="me-2" data-lucide="hash"></i>
                          Transaction Hash / TXID
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-lg referral-link-input"
                          id="transferHash"
                          placeholder="Enter your transaction hash"
                          value={transferHash}
                          onChange={(e) => setTransferHash(e.target.value)}
                          required
                        />
                      </div>

                      <div className="d-grid gap-2">
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg py-3"
                          disabled={isProcessing}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >
                          {isProcessing ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                              Processing Payment...
                            </>
                          ) : (
                            <>
                              <i className="me-2" data-lucide="check-circle"></i>
                              Submit Payment Verification
                            </>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {/* Wallet Payment Method */}
                {paymentMethod === 'wallet' && (
                  <div className="wallet-payment-details">
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="alert alert-warning">
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <h5 className="mb-1">Registration Fees Required</h5>
                              <h2 className="text-dark mb-0">$5 USD</h2>
                            </div>
                            <div className="text-end">
                              <div className="badge bg-warning fs-6">Required Amount</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Current Wallet Balance */}
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="card border-success">
                          <div className="card-header bg-success text-white">
                            <h6 className="mb-0 d-flex align-items-center">
                              <i className="me-2" data-lucide="wallet"></i>
                              Current wallet amount
                            </h6>
                          </div>
                          <div className="card-body">
                            <div className="text-center py-4">
                              <div className="display-1 fw-bold text-success mb-2">
                                ${currentWalletBalance.toFixed(2)}
                              </div>
                              <p className="text-muted mb-0">Available for registration payment</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Balance Status */}
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className={`balance-status-card ${hasSufficientBalance ? 'bg-success' : 'bg-danger'}`}>
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-1">
                                  {hasSufficientBalance ? 'Sufficient Balance ✓' : 'Insufficient Balance ✗'}
                                </h6>
                                <p className="mb-0 small">
                                  {hasSufficientBalance
                                    ? `Your wallet has $${currentWalletBalance.toFixed(2)}, which meets the $${requiredAmount} requirement`
                                    : `You need $${(requiredAmount - currentWalletBalance).toFixed(2)} more to proceed`}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Submit Button - Only show if sufficient balance */}
                    {hasSufficientBalance && (
                      <form onSubmit={handleWalletSubmit}>
                        <div className="d-grid gap-2">
                          <button
                            type="submit"
                            className="btn btn-success btn-lg py-3"
                            disabled={isProcessing}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                          >
                            {isProcessing ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                Processing Activation...
                              </>
                            ) : (
                              <>
                                <i className="me-2" data-lucide="check-circle"></i>
                                Activate Account via Wallet
                              </>
                            )}
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <PaymentPopup />

      <div className="main-wrapper">
        {/* Sidebar with custom scrollbar */}
        <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
          <div className="sidebar-header">
            <a href="#" className="sidebar-brand">
              <i className="me-2" data-lucide="atom"></i>
              Willow <span>Quantum</span>
            </a>
            <div className="sidebar-toggler" onClick={toggleSidebar}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <Sidebar />
        </nav>

        <div className="page-wrapper">
          {/* Navbar */}
          <Navbar />
          {/* Page Content */}
          <div className="page-content container-xxl">
            {/* Stats Cards Row - UPDATED: 4 BOXES IN ONE ROW */}
            <div className="row">
              <div className="col-12 col-xl-12 stretch-card">
                <div className="row flex-grow-1">
                  {/* First Row: 4 Boxes */}
                  <div className="col-md-4 grid-margin stretch-card">
                    <div className="card custom-card">
                      <div className="top-left"></div>
                      <div className="top-right"></div>
                      <div className="bottom-left"></div>
                      <div className="bottom-right"></div>
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-baseline">
                          <h6 className="card-title mb-0">User Details</h6>
                          <div className="dropdown mb-2">
                            <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                              <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
                            </a>
                            <div className="dropdown-menu">
                              {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                                <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                                  <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                                  <span>{action}</span>
                                </a>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 col-md-12 col-xl-5" style={{ width: "100%" }}>

                            <p style={{ marginBottom: "0px", color: "white" }}>User Id : {userData?.user_code}</p>
                            <p style={{ marginBottom: "0px", color: "white" }}>Account Name : {userData?.account_name}</p>
                            <p style={{ marginBottom: "0px", color: "white" }}>Email : {userData?.email}</p>
                          </div>
                          <div className="col-6 col-md-12 col-xl-7">
                            <div id="referralsChart" className="mt-md-3 mt-xl-0"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 grid-margin stretch-card">
                    <div className="card custom-card">
                      <div className="top-left"></div>
                      <div className="top-right"></div>
                      <div className="bottom-left"></div>
                      <div className="bottom-right"></div>
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-baseline">
                          <h6 className="card-title mb-0">Plan Details</h6>
                          <div className="dropdown mb-2">
                            <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                              <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
                            </a>
                            <div className="dropdown-menu">
                              {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                                <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                                  <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                                  <span>{action}</span>
                                </a>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 col-md-12 col-xl-5" style={{ width: "100%" }}>
                            <p style={{ marginBottom: "0px", color: "white" }}>PLan : Awaiting</p>
                            <p style={{ marginBottom: "0px", color: "white" }}>Rank : Awaiting</p>
                            <span style={{ marginBottom: "0px", color: "white" }}>Status : </span>
                            <button
                              className={userData.user_code ? "status-btn active" : "status-btn inactive"}
                            >
                              {userData.user_code ? "Active" : "Inactive"}
                            </button>

                          </div>
                          <div className="col-6 col-md-12 col-xl-7">
                            <div id="referralsChart" className="mt-md-3 mt-xl-0"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Box 1: Total Referrals */}
                  <div className="col-md-4 grid-margin stretch-card">
                    <div className="card custom-card">
                      <div className="top-left"></div>
                      <div className="top-right"></div>
                      <div className="bottom-left"></div>
                      <div className="bottom-right"></div>
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-baseline">
                          <h6 className="card-title mb-0">Total Referrals</h6>
                          <div className="dropdown mb-2">
                            <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                              <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
                            </a>
                            <div className="dropdown-menu">
                              {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                                <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                                  <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                                  <span>{action}</span>
                                </a>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 col-md-12 col-xl-5">
                            <h3 className="mb-2">{userData?.referral_count}</h3>
                            <small className="text-muted">Active Referrals</small>
                          </div>
                          <div className="col-6 col-md-12 col-xl-7">
                            <div id="referralsChart" className="mt-md-3 mt-xl-0"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Box 2: Quantum Main Vault */}
                  <div className="col-md-4 grid-margin stretch-card">
                    <div className="card custom-card">
                      <div className="top-left"></div>
                      <div className="top-right"></div>
                      <div className="bottom-left"></div>
                      <div className="bottom-right"></div>
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-baseline">
                          <h6 className="card-title mb-0">Quantum Main Vault (Fuel)</h6>
                          <div className="dropdown mb-2">
                            <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                              <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
                            </a>
                            <div className="dropdown-menu">
                              {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                                <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                                  <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                                  <span>{action}</span>
                                </a>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 col-md-12 col-xl-5">
                            <h3 className="mb-2">${walletData.quantumMainVault.toLocaleString()}</h3>
                            <small className="text-muted">Fuel Balance</small>
                          </div>
                          <div className="col-6 col-md-12 col-xl-7">
                            <div id="mainVaultChart" className="mt-md-3 mt-xl-0"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Box 3: Quantum Release */}
                  <div className="col-md-4 grid-margin stretch-card">
                    <div className="card custom-card">
                      <div className="top-left"></div>
                      <div className="top-right"></div>
                      <div className="bottom-left"></div>
                      <div className="bottom-right"></div>
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-baseline">
                          <h6 className="card-title mb-0">Quantum Release (Withdrawal)</h6>
                          <div className="dropdown mb-2">
                            <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                              <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
                            </a>
                            <div className="dropdown-menu">
                              {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                                <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                                  <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                                  <span>{action}</span>
                                </a>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 col-md-12 col-xl-5">
                            <h3 className="mb-2">${walletData.quantumRelease.toLocaleString()}</h3>
                            <small className="text-muted">Withdrawal Balance</small>
                          </div>
                          <div className="col-6 col-md-12 col-xl-7">
                            <div id="releaseChart" className="mt-md-3 mt-xl-0"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Box 4: Quantum Current */}
                  <div className="col-md-4 grid-margin stretch-card">
                    <div className="card custom-card">
                      <div className="top-left"></div>
                      <div className="top-right"></div>
                      <div className="bottom-left"></div>
                      <div className="bottom-right"></div>
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-baseline">
                          <h6 className="card-title mb-0">Quantum Current (Liquidity)</h6>
                          <div className="dropdown mb-2">
                            <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                              <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
                            </a>
                            <div className="dropdown-menu">
                              {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                                <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                                  <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                                  <span>{action}</span>
                                </a>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 col-md-12 col-xl-5">
                            <h3 className="mb-2">${walletData.quantumCurrent.toLocaleString()}</h3>
                            <small className="text-muted">Liquidity Balance</small>
                          </div>
                          <div className="col-6 col-md-12 col-xl-7">
                            <div id="currentChart" className="mt-md-3 mt-xl-0"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                   <div className="col-md-4 grid-margin stretch-card">
                    <div className="card custom-card">
                      <div className="top-left"></div>
                      <div className="top-right"></div>
                      <div className="bottom-left"></div>
                      <div className="bottom-right"></div>
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-baseline">
                          <h6 className="card-title mb-0">Quantum Qi-Airdrop</h6>
                          <div className="dropdown mb-2">
                            <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                              <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
                            </a>
                            <div className="dropdown-menu">
                              {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                                <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                                  <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                                  <span>{action}</span>
                                </a>
                              ))}
                            </div>
                          </div>
                        </div>
                         <div className="row">
                          <div className="col-6 col-md-12 col-xl-5">
                            <h3 className="mb-2">${walletData.quantumQiAirdrop.toLocaleString()}</h3>
                            <small className="text-muted">Airdrop Balance</small>
                          </div>
                          <div className="col-6 col-md-12 col-xl-7">
                            <div id="airdropChart" className="mt-md-3 mt-xl-0"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <SponsorLinksTable />

          </div>

          {/* Footer */}
          <footer className="footer d-flex flex-row align-items-center justify-content-center px-4 py-3 border-top small">
            <p className="text-secondary mb-1 mb-md-0">Copyright © 2025 Willow Quantum. All Right Reserved.</p>
          </footer>
        </div>
      </div>
    </>
  );
};

export default Dashboard;